var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningIconinline = function SvgWarningIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C27605",
    d: "M10 0a10 10 0 1 0 10 10A10.02 10.02 0 0 0 10 0m-.77 5.385a.77.77 0 0 1 1.54 0v5.384a.77.77 0 1 1-1.54 0zm.77 10a1.154 1.154 0 1 1 0-2.31 1.154 1.154 0 0 1 0 2.31"
  })));
};
export default SvgWarningIconinline;